module.exports = __webpack_public_path__ + "static/media/MAERSK.e5312b86.svg";